import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import { Link, browserHistory } from 'react-router';
import Spinner from './Spinner';
import { inject } from 'mobx-react';
// import { validateStation } from '../libs/checkPermission';
import { observable } from 'mobx';
import { preference } from '../libs/localStorage';

@inject('stationPermissionStore', 'uiStore')
@observer
export default class FolderHierarchy extends Component {
  static propTypes = {
    folderStore: PropTypes.shape().isRequired,
  }
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  pathname = window.location.pathname;

  @observable activeStation = this.pathname.split('/')[1];

  constructor(props) {
    super(props);

    this.getFilteredFolderHierarchy = this.getFilteredFolderHierarchy.bind(this);
    this.onChangeSearchText = this.onChangeSearchText.bind(this);
  }

  componentWillMount() {
    browserHistory.listen(({ hash }) => {
      if (hash.indexOf('#/station') > -1) this.activeStation = hash.split('?/')[0].split('/')[2]
      else this.activeStation = null;
      if (hash.indexOf('#/station/') !== 0 && this.pathname.indexOf('#/station/') === 0) {
        this.forceUpdate()
      }
      this.pathname = hash;
    })
  }

  onChangeSearchText(event) {
    const { folderStore } = this.props;

    const searchText = event.target.value &&
      event.target.value.toLowerCase();

    folderStore.setSearchFilter(searchText);
  }

  getFilteredFolderHierarchy() {
    const { folderStore } = this.props;

    if (!folderStore.searchFilter) {
      return folderStore.items;
    }

    const foundFolders = folderStore.items.filter(folder => (
      folder.name.toLowerCase().indexOf(folderStore.searchFilter) !== -1
    ));

    const foundFolderIds = foundFolders.map(folder => folder.id);

    const allFolders = folderStore.items;

    const remainingFolders = allFolders
      .filter(folder => (
        foundFolderIds.indexOf(folder.id) === -1
      ));

    const remainingFoldersWithFoundStations = remainingFolders
      .map(folder => {
        const foundStations = folder.stations.filter(station => (
          (station &&
            station.name &&
            station.name.toLowerCase().indexOf(folderStore.searchFilter) !== -1) ||

          (station &&
            station.tags &&
            station.tags.reduce((acc, tag) => {
              if (tag.name.toLowerCase().indexOf(folderStore.searchFilter) !== -1) {
                return true;
              }
              return acc;
            }, false))
        ));

        return Object.assign({}, folder, { stations: foundStations });
      })
      .filter(folder => folder.stations.length > 0);

    return [
      ...foundFolders,
      ...remainingFoldersWithFoundStations,
    ];
  }

  render() {
    const { folderStore, uiStore } = this.props;

    if (folderStore.isLoading) {
      return <Spinner className='white' />;
    }

    const filteredFolderHierarchy = this.getFilteredFolderHierarchy();
    return (
      <div>
        <div className="Search inline-it">
          <i className='fa fa-search' />
          <input placeholder="Search" onChange={this.onChangeSearchText} value={folderStore.searchFilter || ''} />
          {folderStore.searchFilter !== '' && <i className='fa fa-close' style={{ right: 15, color: '#bdbdbd' }} onClick={() => this.onChangeSearchText({ target: { value: '' } })} />}
        </div>
        <div className="FolderHierarchy">
          {filteredFolderHierarchy && filteredFolderHierarchy.sort((a, b) => a.name < b.name ? -1 : 1).map(folder => {
            if (folder.stations.length == 0) return;
            return (
              <details key={folder.id} open>
                <summary className={'listSectionTitle'}>
                  <i className="fa fa-folder-open" aria-hidden="true" />
                  {folder.name ? folder.name : ' -- '}
                </summary>
                <ul>
                  {folder && folder.stations && folder.stations.sort((a, b) => a.name < b.name ? -1 : 1).map(station => (
                    <li
                      key={station.id}
                      onClick={() => {
                        const station_redirect = preference.get().station_redirect;
                        this.context.router.push(`/station/${station.id}/${station_redirect || 'meta-data'}`)
                      }}
                      className={+this.activeStation === +station.id ? 'active-highlight' : ''}
                      data-toggle='tooltop' title={station.name}
                    >
                      <Link to={`/station/${station.id}`}>
                        {station.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </details>
            )
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FolderHierarchy.js